export const categories = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20aesthetic%20sneaker%20display%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20product%20photography%2C%20elegant%20composition%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20high%20detail%2C%20simple%20and%20clean%20aesthetic%20with%20gentle%20shadows&width=800&height=560&seq=cat-shoes-01&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20hoodie%20flat%20lay%20on%20warm%20cream%20surface%2C%20natural%20daylight%2C%20clean%20aesthetic%2C%20neutral%20beige%20tones%2C%20textile%20texture%20visible%2C%20editorial%20product%20photography%2C%20simple%20composition%20with%20soft%20shadows&width=800&height=560&seq=cat-hoodies-02&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20white%20t-shirt%20on%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20aesthetic%2C%20editorial%20photography%2C%20simple%20elegant%20composition%2C%20warm%20neutral%20tones%2C%20high%20detail%20fabric%20texture&width=800&height=560&seq=cat-tshirts-03&orientation=landscape',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20jacket%20displayed%20on%20clean%20cream%20background%2C%20soft%20natural%20daylight%2C%20elegant%20product%20photography%2C%20warm%20neutral%20palette%2C%20simple%20composition%2C%20editorial%20style%20with%20gentle%20shadows&width=800&height=560&seq=cat-jackets-04&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20casual%20pants%20flat%20lay%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%2C%20neutral%20beige%20tones%2C%20textile%20detail%2C%20editorial%20photography%2C%20simple%20composition&width=800&height=560&seq=cat-pants-05&orientation=landscape',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cap%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20composition%2C%20editorial%20style%2C%20gentle%20shadows%20and%20high%20detail&width=800&height=560&seq=cat-headwear-06&orientation=landscape',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20minimalist%20clothing%20set%20on%20soft%20cream%20background%2C%20natural%20daylight%2C%20clean%20aesthetic%2C%20warm%20neutral%20palette%2C%20editorial%20product%20photography%2C%20elegant%20simple%20composition%20with%20soft%20shadows&width=800&height=560&seq=cat-sets-07&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20underwear%20display%20on%20clean%20cream%20surface%2C%20natural%20lighting%2C%20elegant%20aesthetic%2C%20warm%20neutral%20tones%2C%20simple%20composition%2C%20editorial%20photography%2C%20gentle%20shadows%20and%20textile%20texture&width=800&height=560&seq=cat-underwear-08&orientation=landscape',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20sports%20jersey%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20elegant%20composition%2C%20editorial%20style%2C%20high%20detail%20fabric&width=800&height=560&seq=cat-jersey-09&orientation=landscape',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20accessories%20on%20soft%20cream%20background%2C%20natural%20daylight%2C%20clean%20aesthetic%2C%20warm%20neutral%20palette%2C%20editorial%20photography%2C%20simple%20composition%2C%20gentle%20shadows%20and%20high%20detail&width=800&height=560&seq=cat-accessories-10&orientation=landscape',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20elegant%20bag%20displayed%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20composition%2C%20editorial%20style%2C%20leather%20texture%20detail&width=800&height=560&seq=cat-bags-11&orientation=landscape',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20belt%20on%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20elegant%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20composition%2C%20editorial%20style%2C%20leather%20detail%20with%20gentle%20shadows&width=800&height=560&seq=cat-belts-12&orientation=landscape',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20perfume%20bottle%20on%20soft%20cream%20background%2C%20natural%20daylight%2C%20clean%20aesthetic%2C%20warm%20neutral%20palette%2C%20editorial%20photography%2C%20simple%20composition%2C%20glass%20reflection%20detail&width=800&height=560&seq=cat-perfumes-13&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20of%20minimalist%20lifestyle%20items%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20composition%2C%20editorial%20style%2C%20miscellaneous%20objects%20aesthetic&width=800&height=560&seq=cat-other-14&orientation=landscape',
  },
];